export default __webpack_public_path__ + "static/media/JosephSchulze.47549069.jpg";